import {
  SessionActivityTimeOfDay,
  SessionActivityType,
  WorkTimeType,
} from './session-activity-types';
import { SessionDayType } from './session-types';

/**
 * Estimate Unit Types
 */
export enum SessionEstimateItemUnitType {
  Hours = 'hours',
  Miles = 'miles',
  Days = 'days',
  Count = 'count',
  CostumeChanges = 'costume changes',
  Tags = 'tags',
  Doubles = 'doubles', // For use w/AFM side musicians
}

/**
 * Titles
 */
// Web version
export const sessionEstimateItemTitles: Record<string, string> = {
  [WorkTimeType.StraightTime]: 'Straight Time',
  [WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
  [WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
  [WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
  [SessionActivityType.WorkTimeSaturday]: '(Saturday Premium)',
  [SessionActivityType.WorkTimeSunday]: '(Sunday Premium)',
  [SessionActivityType.WorkTimeHoliday]: '(Holiday Premium)',
  [SessionDayType.Saturday]: '(Saturday Premium)', // from api version
  [SessionDayType.Sunday]: '(Sunday Premium)', // from api version
  [SessionDayType.Holiday]: '(Holiday Premium)', // from api version
  Weekend: '(Weekend Premium)',
  [SessionActivityType.WorkTimeNight]: '(Night Premium)',
  [SessionActivityType.WorkTimeLateNight]: '(Late Night Premium)',
  [SessionActivityType.TravelToLocationAfterMidnight]:
    '(Travel After Midnight)',
  [SessionActivityType.TravelFromLocationAfterMidnight]:
    '(Travel After Midnight)',
  [SessionActivityTimeOfDay.Night]: '(Night Premium)', // from api version
  [SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)', // from api version
  [SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)', // from api version
};

// API version
// export const sessionEstimateItemTitles: Record<string, string> = {
//   [WorkTimeType.StraightTime]: 'Straight Time',
//   [WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
//   [WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
//   [WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
//   [SessionDayType.Saturday]: '(Saturday Premium)',
//   [SessionDayType.Sunday]: '(Sunday Premium)',
//   [SessionDayType.Holiday]: '(Holiday Premium)',
//   Weekend: '(Weekend Premium)',
//   [SessionActivityTimeOfDay.Night]: '(Night Premium)',
//   [SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)',
//   [SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)',
// };
